export default {"sm":"468px","md":"768px","lg":"1024px","xl":"1440px","xxl":"1920px","xxxl":"2550px"};